import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UserSettingsService } from '../user-settings.service';
import { ResidentialService } from '../../questionarie-signup/questionnaire-residential/residential.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-notification-details',
  templateUrl: './notification-details.component.html',
  styleUrls: ['./notification-details.component.css'],
})
export class NotificationDetailsComponent implements OnInit {
  deviceWidth;
  circleTitleFontSize;
  circleRadius;
  circleUnitsFontSize;
  hg_accountId;
  url = environment.api_url;
  notificationList;
  questPercentage;
  queryObj = {
    _id: '',
    esiid: '',
    hg_orders_id: '',
    hg_accountId: '',
  };
  updateObj = {
    showNotification: '',
    isRead: false,
  };
  count;
  hideNotificationDetails;
  newNotificationList;
  incompleteNotificationList;
  notifyiterationList = [];
  hidenotificomp = false;
  profile = ['PROFILE', 'COMPLETED'];
  txtcolor = '';
  fontWieght = 'normal';
  subTitleFont;

  constructor(
    private http: HttpClient,
    private router: Router,
    private userSettingsService: UserSettingsService,
    private residentialService: ResidentialService
  ) {
    this.deviceWidth = window.innerWidth;
  }

  ngOnInit() {
    if (this.deviceWidth < 768) {
      this.circleTitleFontSize = '20';
      this.circleUnitsFontSize = '20';
      this.subTitleFont = '12';
      this.circleRadius = '55';
    } else {
      this.circleTitleFontSize = '35';
      this.circleUnitsFontSize = '35';
      this.circleRadius = '80';
      this.subTitleFont = '20';
    }
    this.count = 0;
    this.newNotificationList = [];
    this.incompleteNotificationList = [];
    this.notifyiterationList = [];
    this.hg_accountId = window.location.href.split('/').pop();
    const notifybody = new HttpParams().set('hg_accountId', this.hg_accountId);
    this.http
      .get(this.url + '/getNotification', { params: notifybody })
      .subscribe((res: any) => {
        this.notificationList = res;
        console.log(
          _.sortBy(this.notificationList, function (item) {
            return item;
          })
        );
        var sessionnotification = this.notificationList;
        if (
          this.notificationList &&
          this.notificationList.statusCode &&
          this.notificationList.statusCode === '0010'
        ) {
          this.router.navigateByUrl('/login');
        } else {
          // console.log.log('NotiResult', + this.notificationList);
          if (this.notificationList.length > 0) {

            // var IsHaveEnrollPlans = sessionStorage.getItem(
            //   'IsHaveEnrollPlans',
             
            // );

            var localquestions =  JSON.parse(sessionStorage.getItem(
              'userResponse'
            ));

            var IsHaveEnrollPlans ="";
            if(this.notificationList[0].
              CompletedEnrollmentmsg){

                IsHaveEnrollPlans = "true";

            }

            if(IsHaveEnrollPlans == "true" && (localquestions == null || localquestions.userResponses.length == 0))
            {
             
              if(this.notificationList[0].StraigthPlanUserRequest && (this.notificationList[0].StraigthPlanUserRequest != null || this.notificationList[0].StraigthPlanUserRequest != '') && this.notificationList[0].StraigthPlanUserRequest != undefined)
              {

              }else
              {
                this.notificationList[0].title = 'Congratulations!';
                this.notificationList[0].buttonName = '';
                this.notificationList[0].message = this.notificationList[0].CompletedEnrollmentmsg;
              }
              
            }

            sessionStorage.setItem(
              'ShowAnotherAddress',"true"
            )
            if( this.notificationList[0].title != 'Congratulations!')
            {
              sessionStorage.setItem(
                'ShowAnotherAddress',"false"
              )

            }
          
         

            this.notifyiterationList.push(
              _.sortBy(this.notificationList, function (item) {
                return item;
              })[0]
            );
          }
        }
        sessionStorage.setItem(
          'notifyiterationList',
          JSON.stringify(sessionnotification)
        );
      });

    this.userSettingsService.setShowNotify.subscribe((data) => {
      this.hideNotificationDetails = data.flag;
      if (this.hideNotificationDetails === true) {
        this.viewAllNotification(data.notifyType);
      }
    });
  }

  closenotification(notifyObj, type) {
    this.hidenotificomp = true;
    notifyObj.showNotification = false;
    this.queryObj._id = notifyObj._id;
    this.queryObj.esiid = notifyObj.esiid;
    this.queryObj.hg_accountId = notifyObj.hg_accountId;
    this.queryObj.hg_orders_id = notifyObj.hg_orders_id;
    this.updateObj.showNotification = notifyObj.showNotification;
    if (type === 'close') {
      this.updateObj.isRead = true;
    }
    const body = new HttpParams();
    body.append('queryObj', JSON.stringify(this.queryObj));
    body.append('updateObj', JSON.stringify(this.updateObj));
    this.http
      .post(this.url + '/updateNotification', body)
      .subscribe((res: any) => {
        const result = res;
        this.ngOnInit();
      });
  }

  startOverforheader() {
    const user = sessionStorage.getItem('userObj');
    if (user) {
      //this.showLogin = true;
      let questionnarieObj = [];
      let percentage = '0';
      var hg_accountId = JSON.parse(sessionStorage.getItem('userObj'))._id;
      const body = new HttpParams()
        .append('questionnarieObj', questionnarieObj.toString())
        .append('userObj', user)
        .append('percentage', percentage)
        .append('hg_accountId', hg_accountId);
      this.queryObj.hg_accountId = hg_accountId;

      this.http
        .get(this.url + '/getHgUser', { params: body })
        .subscribe((res: any) => {
          const result = res;
          if (result && result.statusCode && result.statusCode === '0010') {
          } else {
            if (
              result.user.questionStatusObj != null &&
              result.user.questionStatusObj.questionStatus != 'Completed' &&
              result.userResponses &&
              result.userResponses.length > 0
            ) {
              this.http
                .post(this.url + '/deleterecordbyPending', this.queryObj)
                .subscribe((notifyres) => {
                  const notifyresult = notifyres;
                  sessionStorage.removeItem('questionStatusObj');
                  this.residentialService.userResponse.userResponses = [];
                  sessionStorage.removeItem('userResponse');
                  sessionStorage.removeItem('percentage');
                  this.residentialService.messageService({});
                  this.router.navigateByUrl('/residentialQues');
                });
            } else {
              this.residentialService.userResponse.userResponses = [];
              this.residentialService.messageService({
                currentId: null,
                questionStatus: null,
              });
              sessionStorage.removeItem('questionStatusObj');
              sessionStorage.removeItem('userResponse');
              sessionStorage.removeItem('percentage');
              this.residentialService.messageService({});
              this.router.navigateByUrl('/residentialQues');
            }
          }
        });
    } else {
      sessionStorage.removeItem('questionStatusObj');
      sessionStorage.removeItem('userResponse');
      sessionStorage.removeItem('percentage');
      this.residentialService.messageService({});
      this.residentialService.userResponse.userResponses = [];
      this.residentialService.isStartOver = true;
      this.router.navigateByUrl('/residentialQues');
    }
  }


  startOver() {
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      var questionStatusObj1 = {
        percentage: '',
        questionStatus: '',
        questionStep: '001',
        type: '',
      };
    }

    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      var hg_accountId = JSON.parse(sessionStorage.getItem('userObj'))._id;
      const body = new HttpParams().append('hg_accountId', hg_accountId);
      this.queryObj.hg_accountId = hg_accountId;
      this.http
        .get(this.url + '/getHgUser', { params: body })
        .subscribe((res: any) => {
          const result = res;
          if (result && result.statusCode && result.statusCode === '0010') {
          } else {
            if (result.userResponses && result.userResponses.length > 0) {
              this.http
                .post(this.url + '/deleterecordbyPending', this.queryObj)
                .subscribe((notifyres) => {
                  const notifyresult = notifyres;

                  console.log(
                    'delete record successfully!!!',
                    this.residentialService
                  );
                  this.residentialService.currentId = '000';
                  this.residentialService.nextId = '001';
                  this.residentialService.selectedType = '';
                  this.residentialService.questionnaireStatusObj = {
                    percentage: '0',
                    questionStatus: '',
                    questionStep: '',
                    type: '',
                  };
                  this.residentialService.messageService({});
                  this.residentialService.userResponse.userResponses = [];
                  this.residentialService.isStartOver = true;
                  sessionStorage.removeItem('questionStatusObj');
                  sessionStorage.removeItem('userResponse');
                  sessionStorage.removeItem('percentage');
                  sessionStorage.clear();
                  this.residentialService.messageService({
                    currentId: null,
                    questionStatus: null,
                  });
                  const body = new HttpParams();
                  const hg_accountId = window.location.href.split('/').pop();
                  const user = {
                    _id: hg_accountId,
                    accountId: hg_accountId,
                    questionStatusObj: questionStatusObj1,
                  };
                  body.append('user', JSON.stringify(user));
                  body.append('hg_accountId', hg_accountId);
                  console.log('body....', body);
                  this.http
                    .post(this.url + '/updateuserstatusQues', body)
                    .subscribe((res: any) => {
                      //console.log("jjuse..",res);
                    });
                  this.router.navigateByUrl('/residentialQues');
                });
            } else {
              sessionStorage.removeItem('questionStatusObj');
              sessionStorage.removeItem('userResponse');
              sessionStorage.removeItem('percentage');
              sessionStorage.clear();
              this.residentialService.messageService({
                currentId: null,
                questionStatus: null,
              });
              this.residentialService.messageService({});
              this.router.navigateByUrl('/residentialQues');
            }
          }
        });
    } else {
      this.residentialService.messageService({});
      this.router.navigateByUrl('/residentialQues');
    }
  }

  completeProcess(notifyObj) {
    this.residentialService.isStartOver = false;
    if (notifyObj.type === 'questionnarie_not_completed') {
      this.userSettingsService.questionNotificationObj = notifyObj;
    } else if (
      notifyObj.type === 'enrollment_not_completed' ||
      notifyObj.type === 'renewal'
    ) {
      this.userSettingsService.enrollNotificationObj = notifyObj;
    }
    // getting the username to save in localstorage for add another address flow.
    const userName = localStorage.getItem('userName');

    // To remove the existing user response for renewal type
    this.residentialService.questionFlowType = notifyObj.type;
    localStorage.setItem('userName', userName);

    if (
      notifyObj.type === 'renewal' ||
      notifyObj.type === 'add-address' ||
      notifyObj.type === 'enrollment_not_completed'
    ) {
      this.residentialService.messageService({});
      this.residentialService.userResponse.userResponses = [];

      // for renewal
      if (notifyObj.type === 'renewal') {
        // clear existing userresponse
        sessionStorage.clear();
        this.residentialService.messageService({});
        this.residentialService.userResponse.userResponses = [];
      }

      const body = new HttpParams().append(
        'hg_accountId',
        notifyObj.hg_accountId
      );
      if (notifyObj.userAddress !== undefined)
        body.append('userAddress', notifyObj.userAddress);
      if (notifyObj.esiid !== null) body.append('esiid', notifyObj.esiid);

      // get the questionnarie response
      this.http
        .get(this.url + '/residentialRes', { params: body })
        .subscribe((res: any) => {
          const questionarieRes = res;
          if (!_.isEmpty(questionarieRes)) {
            // some cases not getting the userResponse from session
            if (notifyObj.type === 'enrollment_not_completed') {
              this.residentialService.userResponse.userResponses =
                questionarieRes.res_user_responses;
           

              
            var IsHaveEnrollPlans = sessionStorage.getItem(
              'IsHaveEnrollPlans',
             
            );

              if(IsHaveEnrollPlans == "true")
              {
                var localquestions =  JSON.parse(sessionStorage.getItem(
                  'userResponse'
                ));
  
                 if(localquestions != null && localquestions['userResponses'].length != 0)
                 {
    
                    sessionStorage.setItem(
                      'userResponse',
                      JSON.stringify(localquestions)
                    );
  


                    if(localquestions['userResponses'].length >= 17)
                    {
                      var goto_success = true; 
                      const checkservice = _.findWhere(localquestions['userResponses'], {
                        res_question_id: '002',
                      });
              
                      if(checkservice != undefined && checkservice != null &&  checkservice.fieldValue == 'New Service'   )
                      {
                        const terms = _.findWhere(localquestions['userResponses'], {
                          res_question_id: '0026',
                        });
                
                        if(terms != undefined && terms != null && ( terms.fieldValue != '' || terms.fieldValue != null )  )
                        {
                
                   
                        }else
                        {
                          goto_success = false;
                        }
                      }else
                      {
                        const usagehistory = _.findWhere(localquestions['userResponses'], {
                          res_question_id: '0030',
                        });
  
                        if(usagehistory != undefined && usagehistory != null  )
                        {
                          goto_success = true;
                        }else
                        {
                          goto_success = false;
                        }
  
                      
  
  
                      }
  
                      if(goto_success)
                      {
                        
                        if((notifyObj['StraigthPlanUserRequest'] != null || notifyObj['StraigthPlanUserRequest'] != '') && notifyObj['StraigthPlanUserRequest'] != undefined)
                        {
                          sessionStorage.setItem('zipcode',notifyObj['StraigthPlanUserRequest']['zipcode'])
                          sessionStorage.setItem('utilitycode',notifyObj['StraigthPlanUserRequest']['utilityName'])
                          sessionStorage.removeItem('userResponse')
                          this.router.navigate(['pre-success']);
                          
                        }else
                        {
                          this.router.navigate(['pre-success']);
          
                        }
                       
                        
                      }else
                      {
                        const lastArr = _.last(localquestions['userResponses']);
                        this.residentialService.messageService({
                          currentId: lastArr.res_question_id,
                        });
                       
                        if((notifyObj['StraigthPlanUserRequest'] != null || notifyObj['StraigthPlanUserRequest'] != '') && notifyObj['StraigthPlanUserRequest'] != undefined)
                        {
                          sessionStorage.setItem('zipcode',notifyObj['StraigthPlanUserRequest']['zipcode'])
                          sessionStorage.setItem('utilitycode',notifyObj['StraigthPlanUserRequest']['utilityName'])
                          sessionStorage.removeItem('userResponse')
                          this.router.navigate(['pre-success']);
                          
                        }else
                        {
                          this.router.navigateByUrl('/residentialQues');
          
                        }
  
                      }
  
  
                    
  
                    }else
                    {
                      const lastArr = _.last(localquestions['userResponses']);
                      this.residentialService.messageService({
                        currentId: lastArr.res_question_id,
                      });



                      if((notifyObj['StraigthPlanUserRequest'] != null || notifyObj['StraigthPlanUserRequest'] != '') && notifyObj['StraigthPlanUserRequest'] != undefined)
                      {
                        sessionStorage.setItem('zipcode',notifyObj['StraigthPlanUserRequest']['zipcode'])
                        sessionStorage.setItem('utilitycode',notifyObj['StraigthPlanUserRequest']['utilityName'])
                        sessionStorage.removeItem('userResponse')
                        this.router.navigate(['pre-success']);
                        
                      }else
                      {
                        this.router.navigateByUrl('/residentialQues');
        
                      }
  
                    }
  
    


                    // const lastArr = _.last(localquestions['userResponses']);
                    // this.residentialService.messageService({
                    //   currentId: lastArr.res_question_id,
                    // });
                    // this.router.navigateByUrl('/residentialQues');
    
                
                 }
                 else
                 {   
                
  
                  this.residentialService.messageService({
                    currentId: '000',
                  });
                  const questionObj =
                    '{"questionStatus":"Quitted","questionStep":"000","type":"","property":"","percentage":null}';
                  sessionStorage.setItem('questionStatusObj', questionObj);
  
                  if((notifyObj['StraigthPlanUserRequest'] != null || notifyObj['StraigthPlanUserRequest'] != '') && notifyObj['StraigthPlanUserRequest'] != undefined)
                  {
                    sessionStorage.setItem('zipcode',notifyObj['StraigthPlanUserRequest']['zipcode'])
                    sessionStorage.setItem('utilitycode',notifyObj['StraigthPlanUserRequest']['utilityName'])
                    sessionStorage.removeItem('userResponse')
                    this.router.navigate(['pre-success']);
                    
                  }else
                  {
                    this.router.navigateByUrl('/residentialQues');
    
                  }
  
                 
                 }
  
              }else
              {

                sessionStorage.setItem(
                  'userResponse',
                  JSON.stringify(this.residentialService.userResponse)
                );

                if((notifyObj['StraigthPlanUserRequest'] != null || notifyObj['StraigthPlanUserRequest'] != '') && notifyObj['StraigthPlanUserRequest'] != undefined)
                {
                  sessionStorage.setItem('zipcode',notifyObj['StraigthPlanUserRequest']['zipcode'])
                  sessionStorage.setItem('utilitycode',notifyObj['StraigthPlanUserRequest']['utilityName'])
                  sessionStorage.removeItem('userResponse')
                  this.router.navigate(['pre-success']);
                }
                else
                {
                  this.router.navigate([notifyObj.buttonUrl]);
  
                }

                
              }




              //this.router.navigate(['pre-success']);
           
            } else {
              sessionStorage.setItem('questionId', questionarieRes._id);
              sessionStorage.setItem('formateAddress', notifyObj.userAddress);
              this.residentialService.userResponse.userResponses.push(
                questionarieRes['res_user_responses'][0]
              );
              this.residentialService.serviceResObj = _.findWhere(
                questionarieRes['res_user_responses'],
                { res_question_id: '002' }
              );
              this.residentialService.userResponse.userResponses.push(
                _.findWhere(questionarieRes['res_user_responses'], {
                  res_question_id: '008',
                })
              );
              const houseHold = _.findWhere(
                questionarieRes['res_user_responses'],
                { res_question_id: '0014' }
              );
              if (!_.isEmpty(houseHold)) {
                this.residentialService.childrens =
                  houseHold.fieldValue.children;
                this.residentialService.adults = houseHold.fieldValue.adults;
              }

              if((notifyObj['StraigthPlanUserRequest'] != null || notifyObj['StraigthPlanUserRequest'] != '') && notifyObj['StraigthPlanUserRequest'] != undefined)
              {
          
                sessionStorage.setItem('zipcode',notifyObj['StraigthPlanUserRequest']['zipcode'])
                sessionStorage.setItem('utilitycode',notifyObj['StraigthPlanUserRequest']['utilityName'])
                sessionStorage.removeItem('userResponse')
                this.router.navigate(['pre-success']);
              }else
              {
                this.router.navigate([notifyObj.buttonUrl]);

              }
            }
          }else
          {
            if((notifyObj['StraigthPlanUserRequest'] != null || notifyObj['StraigthPlanUserRequest'] != '') && notifyObj['StraigthPlanUserRequest'] != undefined)
              {
          
                sessionStorage.setItem('zipcode',notifyObj['StraigthPlanUserRequest']['zipcode'])
                sessionStorage.setItem('utilitycode',notifyObj['StraigthPlanUserRequest']['utilityName'])
                sessionStorage.removeItem('userResponse')
                this.router.navigate(['pre-success']);
              }
          }
        });
    } else {
      // for questionnarie not completed
      const searchObj = new HttpParams().append(
        'hg_accountId',
        notifyObj.hg_accountId
      );
      if (notifyObj.userAddress !== undefined)
        searchObj.append('userAddress', notifyObj.userAddress);
      if (notifyObj.esiid !== null) searchObj.append('esiid', notifyObj.esiid);
      // get the questionnarie response
      this.http
        .get(this.url + '/residentialRes', { params: searchObj })
        .subscribe((res: any) => {
          const questionarieRes = res;
          if (!_.isEmpty(questionarieRes)) {
            const lastArr = _.last(questionarieRes['res_user_responses']);
            this.residentialService.messageService({
              currentId: lastArr.res_question_id,
            });
            this.router.navigate([notifyObj.buttonUrl]);
          } else {
            this.residentialService.messageService({
              currentId: null,
              questionStatus: null,
            });
            sessionStorage.removeItem('questionStatusObj');
            sessionStorage.setItem(
              'userResponse',
              questionarieRes['res_user_responses']
            );
            sessionStorage.setItem('percentage', notifyObj.percentage);
            this.residentialService.messageService({});
            this.router.navigateByUrl('/residentialQues');
          }
        });
    }

   

  }

  viewAllNotification(type) {
    if (this.notificationList.length > 0) {
      for (let i = 0; i < this.notificationList.length; i++) {
        const notification = this.notificationList[i];
        if (notification.showNotification === true) {
          this.closenotification(notification, 'viewClose');
        }
      }
      this.hidenotificomp = true;
      if (type === 'notify') {
        this.userSettingsService.setNotifyPanelFlag({ flag: true });
      }
    }
  }

  displayStartOverLink(title) {
    return title.includes('Congratulations!') ||
      title.includes('Deposit Required to Start')
      ? true
      : false;
  }
}
